import React from "react";
import { useLang } from "../i18n/LanguageContext";
import { Quote, Star } from "lucide-react";

export default function Testimonials() {
  const { t } = useLang();
  return (
    <section id="testimonials" data-testid="testimonials-section" className="bg-black py-24 sm:py-32 border-t border-neutral-900">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="max-w-3xl mb-14">
          <div className="flex items-center gap-3 text-orange-500 font-mono-label text-xs uppercase tracking-[0.25em] mb-5">
            <span className="w-8 h-px bg-orange-500" /> {t.testimonials.label}
          </div>
          <h2 className="font-display uppercase text-white text-4xl sm:text-5xl lg:text-6xl leading-[0.95]">
            {t.testimonials.title}
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
          {t.testimonials.items.map((it, i) => (
            <div
              key={i}
              data-testid={`testimonial-${i}`}
              className="relative bg-neutral-950 border border-neutral-900 hover:border-orange-500/50 transition-colors p-7 sm:p-8 rounded-sm flex flex-col"
            >
              <Quote className="absolute top-6 right-6 text-orange-500/20" size={40} />
              <div className="flex gap-1 mb-5 text-orange-500">
                {[...Array(5)].map((_, idx) => (
                  <Star key={idx} size={14} fill="currentColor" />
                ))}
              </div>
              <p className="text-neutral-200 text-base leading-relaxed flex-1">&ldquo;{it.quote}&rdquo;</p>
              <div className="mt-6 pt-5 border-t border-neutral-900">
                <div className="font-display uppercase text-white text-lg leading-tight">{it.name}</div>
                <div className="text-xs text-neutral-500 font-mono-label uppercase tracking-wider mt-1">{it.area}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
